import employeeDashboardEmployeeApi from '../../api/employee/dashboard'

export const state = () => ({
  rankingUser: [],
  rankingFile: [],
  newFile: {},
  summary: {},
  metadata: {},
  notification: {},
  notificationAmount: null,
  newFileLoading: false
})

export const getter = {}

export const mutations = {
  RANKING_USER (state, slug) {
    state.rankingUser = [ ...slug ]
  },
  RANKING_FILE (state, slug) {
    state.rankingFile = [ ...slug ]
  },
  NEW_FILE (state, slug) {
    state.newFile = { ...slug }
  },
  SUMMARY (state, slug) {
    state.summary = { ...slug }
  },
  METADATA (state, slug) {
    state.metadata = { ...slug }
  },
  NOTIFICATION (state, slug) {
    state.notificationAmount = slug.total_notifications
    state.notification = slug.notifications.data
  },
  UPDATE_NOTIFICATION (state, slug) {
    state.idFile = slug.file_id
  },
  CHANGE_NEW_FILE_LOADING (state, slug) {
    state.loading = slug
  }
}

export const actions = {
  async getRankingFile ({commit}, params) {
    try {
      const res = await employeeDashboardEmployeeApi.getRankingFile(params)
      if (res.status === 200) {
        commit('RANKING_FILE', res.data.data)
        commit('METADATA', res.data.metadata)
      }
    } catch (error) {

    }
  },
  async getRankingUser ({commit}, params) {
    try {
      const res = await employeeDashboardEmployeeApi.getRankingUser(params)
      if (res.status === 200) {
        commit('RANKING_USER', res.data.data)
      }
    } catch (error) {

    }
  },
  async getNewFile ({commit}, params) {
    commit('CHANGE_NEW_FILE_LOADING', true)
    try {
      const res = await employeeDashboardEmployeeApi.getNewFile(params)
      if (res.status === 200) {
        commit('NEW_FILE', res.data)
        commit('CHANGE_NEW_FILE_LOADING', false)
      }
    } catch (error) {

    }
  },
  async getSummary ({commit}, params) {
    try {
      const res = await employeeDashboardEmployeeApi.getSummary(params)
      if (res.status === 200) {
        commit('SUMMARY', res.data.data)
      }
    } catch (error) {

    }
  },
  async getNotification ({commit}, params) {
    try {
      const res = await employeeDashboardEmployeeApi.getNotification(params)
      if (res.status === 200) {
        commit('NOTIFICATION', res.data.data)
      }
    } catch (error) {

    }
  },
  async updateNotification ({commit}, params) {
    try {
      const res = await employeeDashboardEmployeeApi.updateNotification(params)
      if (res.status === 201) {
        commit('UPDATE_NOTIFICATION', res.data)
        const resList = await employeeDashboardEmployeeApi.getNotification({page: 1})
        if (resList.status === 200) {
          commit('NOTIFICATION', resList.data.data)
        }
      }
    } catch (error) {

    }
  }
}

export default {
  namespaced: true,
  state,
  getter,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/employee/dashboard.js